import urls from './baseUrl'

function stripTrailingSlash(value) {
  return String(value || '').replace(/\/+$/, '')
}

function getProductionRootDomain() {
  if (typeof window === 'undefined') return ''
  const hostname = window.location.hostname.toLowerCase()

  if (hostname === 'superex.live' || hostname.endsWith('.superex.live')) {
    return 'superex.live'
  }
  if (hostname === 'superex.com' || hostname.endsWith('.superex.com')) {
    return 'superex.com'
  }
  return ''
}

function resolveNewWebUrl() {
  const configured = stripTrailingSlash(process.env.VUE_APP_NEW_WEB_URL)
  if (configured) return configured

  switch (process.env.NODE_ENV) {
    case 'development':
      return 'http://localhost:3000'
    case 'test':
    case 'tests':
      return 'https://new-www.superex.bike'
    case 'production': {
      const rootDomain = getProductionRootDomain()
      return rootDomain
        ? `https://www.${rootDomain}`
        : 'https://www.superex.com'
    }
    default:
      return stripTrailingSlash(urls.linkUrl)
  }
}

function resolveOldArchitectureUrl() {
  const configured = stripTrailingSlash(process.env.VUE_APP_OLD_PAYMENT_URL)
  if (configured) return configured

  switch (process.env.NODE_ENV) {
    case 'development':
      return 'http://localhost:8989'
    case 'test':
    case 'tests':
      return 'https://new-superpay.superex.bike'
    case 'production': {
      const rootDomain = getProductionRootDomain()
      return rootDomain
        ? `https://superpay.${rootDomain}`
        : 'https://superpay.superex.com'
    }
    default:
      return stripTrailingSlash(urls.linkUrl)
  }
}

// Keep the original legacy target available for the pages that have not moved
// to newWeb (currently the third-party-payment merchant center).
urls.oldArchitectureUrl = resolveOldArchitectureUrl()
urls.newArchitectureUrl = resolveNewWebUrl()
urls.linkUrl = urls.newArchitectureUrl

export const oldArchitectureUrl = urls.oldArchitectureUrl
export const newArchitectureUrl = urls.newArchitectureUrl

export default urls
